<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color page-card">
        <v-card>
          <v-card-title class="mx-3">
            {{ $t("Notification.ObjectName") }}
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$router.push('/')"
                  >fa-times
                </v-icon>
              </template>
              <span>
                {{ $t("SettingNav.home") }}
              </span>
            </v-tooltip>
          </v-card-title>
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
          <div>
            <v-expansion-panels multiple accordion>
              <v-card width="100%">
                <v-card-text>
                  <v-timeline dense align-top class="py-0">
                    <v-slide-x-reverse-transition group hide-on-leave>
                      <v-timeline-item
                        v-for="(item, i) in announcement"
                        :key="i"
                        :color="
                          item.is_read
                            ? 'primary'
                            : 'danger'
                        "
                        icon="fa-bell"
                        fill-dot
                      >
                        <v-card color="topbar">
                          <v-card-title
                            class="text-h6"
                            @click.stop="showFullContent(i)"
                            style="cursor: pointer"
                          >
                            {{ item.title }}
                            <v-icon v-if="!item.isFullContent" class="ml-2"
                              >fa-angle-double-down</v-icon
                            >
                            <v-icon v-else class="ml-2"
                              >fa-angle-double-up</v-icon
                            >
                          </v-card-title>
                          <v-card-text class="text--primary">
                            <span v-if="!item.isFullContent">{{
                              item.short_content
                            }}</span>
                            <span v-else v-html="item.content"></span>
                            <v-row dense class="mt-10">
                              <v-col cols="12" sm="12" md="4">
                                <v-row dense align="center" class="pa-1">
                                  <span class="vertical-date small">
                                    {{ item.created_text }}<br />
                                    <span style="color: #1ab394">
                                      {{ item.created }}
                                    </span>
                                  </span>
                                </v-row>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="12"
                                md="8"
                                align-self="center"
                              >
                                <v-row
                                  dense
                                  align="center"
                                  class="search-controls"
                                >
                                  <v-spacer />
                                  <!-- 标记已读 -->
                                  <v-btn
                                    small
                                    color="primary"
                                    dark
                                    class="ms-1"
                                    @click="isRead(item)"
                                    v-if="
                                      !item.is_read
                                    "
                                  >
                                    <v-icon x-small class="pe-1"
                                      >fa-check</v-icon
                                    >
                                    {{ $t("Notification.read") }}
                                  </v-btn>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-timeline-item>
                    </v-slide-x-reverse-transition>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-expansion-panels>
          </div>
        </v-card>
      </v-sheet>
      <v-sheet class="transparent-background-color page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  :href="'/'"
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("SettingNav.home") }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn color="primary" block @click="isAllRead()">
                  {{ $t("Notification.allRead") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Announcement from "@/api/announcement";

export default {
  components: {
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("App.notification"),
        disabled: true,
        href: "/notification",
      },
    ],
    accountUserID() {
      return this.accountUser ? this.accountUser.supplier_id : "";
    },
    ...mapState(["loading", "accountInfo", "accountUser"]),
  },

  data: () => ({
    announcement: [],
  }),

  mounted() {
    this.getAnnouncementFromAPI();
  },

  methods: {
    getAnnouncementFromAPI() {
      if (this.accountUserID != "") {
        Announcement.fetch({ supplier_id: this.accountUserID }).then(
          function (response) {
            if (response.data.status.isOK()) {
              Announcement.getUnreadAnnouncementsCount();
              this.announcement = response.data.announcements;
              this.announcement.forEach((column) => {
                column["isFullContent"] = false;
              });
            }
          }.bind(this)
        );
      }
    },
    isAllRead() {
      let data = {
        supplier_id: this.accountUserID,
      };
      Announcement.readAllAnnouncement(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAnnouncementFromAPI();
          }
        }.bind(this)
      );
    },
    isRead(item) {
      let data = {
        supplier_id: this.accountUserID,
      };
      if (item && Object.keys(item).length > 0) {
        data["announcement_id"] = item.id;
      }
      Announcement.readAnnouncement(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAnnouncementFromAPI();
          }
        }.bind(this)
      );
    },

    showFullContent(announcementKey) {
      if (this.announcement[announcementKey].isFullContent) {
        this.announcement[announcementKey].isFullContent = false;
      } else {
        this.announcement[announcementKey].isFullContent = true;
      }
      this.$forceUpdate();
    },
  },

  watch: {
    accountUserID() {
      this.getAnnouncementFromAPI();
    },
  },
};
</script>